<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxFill>
  <div class="content_container" fxLayout="row">
    <div fxLayout="row" class="full-width">
      <as-split direction="horizontal">
        <as-split-area [size]="30" [minSize]="15">
          <div
            class="new_list_container mat-elevation-z0 full-height overflow-auto"
            fxLayout="column"
          >
            <!-- header -->
            <div class="new_header_container">
              <span id="workflowTitle" class="subtitle" i18n="workflows list header@@workflows"
                >workflows</span
              >
              <div class="expand"></div>
              <button
                id="add_new_workflow_button"
                mat-icon-button
                class="add-button"
                color="secondary"
                matTooltip="Add new workflow"
                i18n-matTooltip="@@addNewWorkflow"
                aria-label="add-workflow"
                (click)="openWorkflowDialog()"
              >
                <fa-icon class="icon" [icon]="faPlus" aria-label="add workflow button"></fa-icon>
              </button>
            </div>

            <!-- Search input -->
            <mat-form-field appearance="outline" class="search-field">
              <mat-label i18n="Search name or description@@searchWorkflows"
                >Search name or description</mat-label
              >
              <input matInput [(ngModel)]="searchText" (ngModelChange)="onSearchChange($event)" />
              <fa-icon id="search_icon" matSuffix class="icon" [icon]="faSearch"></fa-icon>
            </mat-form-field>

            <!-- Filter chips -->
            <div class="filter-chips hide-checkmark">
              <mat-chip-listbox aria-label="Workflow filters" selectable multiple>
                <mat-chip-option
                  [selected]="filters.showPublished"
                  (click)="toggleFilter('showPublished')"
                  [disableRipple]="true"
                  matTooltip="Show published workflows"
                  i18n-matTooltip="@@showPublishedWorkflows"
                  class="filter-chip"
                >
                  <span i18n="Published@@published">Published</span>
                </mat-chip-option>
                <mat-chip-option
                  [selected]="filters.showDrafts"
                  (click)="toggleFilter('showDrafts')"
                  [disableRipple]="true"
                  matTooltip="Show draft workflows"
                  i18n-matTooltip="@@showDraftWorkflows"
                  class="filter-chip"
                >
                  <span i18n="Drafts@@drafts">Drafts</span>
                </mat-chip-option>

                <mat-chip-option
                  [selected]="filters.showEditableOnly"
                  (click)="toggleFilter('showEditableOnly')"
                  [disableRipple]="true"
                  matTooltip="Show editable workflows"
                  i18n-matTooltip="@@showEditableWorkflows"
                  class="filter-chip"
                >
                  <span i18n="Editable@@editable">Editable</span>
                </mat-chip-option>
              </mat-chip-listbox>

              <button
                mat-icon-button
                class="clear-filters"
                (click)="clearFilters()"
                matTooltip="Clear all filters"
                *ngIf="hasActiveFilters"
                aria-label="Clear filters"
              >
                <fa-icon
                  class="icon"
                  [icon]="faFilterSlash"
                  aria-label="user settings button"
                ></fa-icon>
              </button>
            </div>
            <div fxLayout="row">
              <div class="list-count">
                <span *ngIf="filteredWorkflows.length > 0">
                  <ng-container
                    *ngIf="filteredWorkflows.length < workflows.length; else allFiltered"
                    ><span
                      i18n="Showing Number Of filtered Workflows@@showingNumberOfFilteredWorkflows"
                      >{{ filteredWorkflows.length }} of {{ workflows.length }}</span
                    >&nbsp;<span i18n="@@workflows">workflows</span>
                  </ng-container>
                  <ng-template #allFiltered>
                    <span>
                      {{ filteredWorkflows.length }}&nbsp;<span i18n="@@workflows"
                        >workflows</span
                      ></span
                    >
                  </ng-template>
                </span>
              </div>

              <div class="list-sort" fxLayout="row">
                <button mat-button color="primary" class="sort-button" (click)="toggleSortOrder()">
                  <span
                    *ngIf="sortCriteria == SortCriteria.UPDATED_DATE"
                    class="sort-button-text"
                    i18n="Last updated@@lastUpdatedSort"
                    >Last updated</span
                  >
                  <span
                    *ngIf="sortCriteria == SortCriteria.ALPHABETICAL"
                    class="sort-button-text"
                    i18n="Alphabetical@@alphabeticalSort"
                    >Alphabetical</span
                  >
                  <fa-icon *ngIf="isAscending" class="icon" [icon]="faArrowUpShortWide"></fa-icon>
                  <fa-icon
                    *ngIf="!isAscending"
                    class="icon"
                    [icon]="faArrowDownShortWide"
                  ></fa-icon>
                </button>
                <div class="sort-menu">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <fa-icon class="sort-menu-icon" [icon]="faSortDown"></fa-icon>
                  </button>
                  <mat-menu #menu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="changeSortCriteria(SortCriteria.UPDATED_DATE)">
                      <div fxLayout="row">
                        <div class="sort-text-container">
                          <span class="sort-criteria-list-item" i18n="Last updated@@lastUpdatedSort"
                            >Last updated</span
                          >
                        </div>
                        <div class="sort-check-icon-container">
                          <fa-icon
                            *ngIf="sortCriteria == SortCriteria.UPDATED_DATE"
                            class="icon sort-criteria-list-item-icon"
                            [icon]="faCheck"
                          ></fa-icon>
                        </div>
                      </div>
                    </button>
                    <button mat-menu-item (click)="changeSortCriteria(SortCriteria.ALPHABETICAL)">
                      <div fxLayout="row">
                        <div class="sort-text-container">
                          <span
                            class="sort-criteria-list-item"
                            i18n="Alphabetical@@alphabeticalSort"
                            >Alphabetical</span
                          >
                        </div>
                        <div class="sort-check-icon-container">
                          <fa-icon
                            *ngIf="sortCriteria == SortCriteria.ALPHABETICAL"
                            class="icon sort-criteria-list-item-icon"
                            [icon]="faCheck"
                          ></fa-icon>
                        </div>
                      </div>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
            <mat-divider></mat-divider>
            <ng-template #workflowItemTemplate let-data="data">
              <div class="workflow-item-container">
                <div class="workflow-item-content">
                  <span class="item-title workflow-item-title">{{ data.name || data.title }}</span>
                  <span class="version-text workflow-item-version">{{
                    getWorkflowVersionText(data)
                  }}</span>
                </div>

                <div class="workflow-item-actions">
                  <div
                    *ngIf="data.routerState?.workflow?.is_draft"
                    class="badges-container workflow-badges-container"
                  >
                    <mat-chip-set class="item-chip">
                      <mat-chip
                        matTooltip="Unpublished draft available"
                        i18n-matTooltip="@@workflow.badge.unpublished_draft"
                        ><span i18n="@@workflow.badge.draft">Draft</span>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                  <div
                    *ngIf="data.routerState?.workflow?.availableInDesigner"
                    class="designer-icon-container"
                    matTooltip="Editable"
                    i18n-matTooltip="Editable@@editable"
                  >
                    <fa-icon [icon]="faPenRuler"></fa-icon>
                  </div>
                </div>
              </div>
            </ng-template>

            <div class="list-content">
              <div class="loading-container" *ngIf="isLoading">
                <fa-icon
                  class="icon loading_spinner"
                  [icon]="faSpinnerThird"
                  aria-label="user settings button"
                ></fa-icon>
              </div>
              <cdk-virtual-scroll-viewport
                *ngIf="!isLoading && filteredWorkflows.length"
                itemSize="64"
                class="full-height new_list_item_container"
              >
                <app-standard-list-item
                  *cdkVirtualFor="
                    let workflow of filteredWorkflows;
                    let i = index;
                    trackBy: trackByIdx
                  "
                  [item]="transformWorkflowToItem(workflow)"
                  [isSelected]="isWorkflowSelected(workflow)"
                  (itemClick)="onWorkflowClick($event)"
                  [template]="workflowItemTemplate"
                >
                </app-standard-list-item>
              </cdk-virtual-scroll-viewport>
              <div class="empty-state" *ngIf="!isLoading && !filteredWorkflows.length">
                <span i18n="No workflows to display@@noWorkflows">No workflows to display</span>
              </div>
            </div>
          </div>
        </as-split-area>
        <as-split-area [size]="70" [minSize]="30">
          <div class="detail">
            <router-outlet></router-outlet>
          </div>
        </as-split-area>
      </as-split>
    </div>
  </div>
</div>

<!-- Workflow Creation Template -->
<ng-template #workflowCreationTemplate>
  <app-workflow-creation
    (cancel)="closeWorkflowDialog()"
    [title]="dialogTitle"
  ></app-workflow-creation>
</ng-template>
